import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

interface SaveDialogProps {
  initialName?: string;
  onClose: () => void;
  onConfirm: (name: string) => void;
}

const SaveDialog: React.FC<SaveDialogProps> = ({ initialName, onClose, onConfirm }) => {
  const [name, setName] = useState(initialName || `sprite-${Date.now()}`);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const n = name.trim();
    if (!n) return;
    onConfirm(n);
  };

  const overlay = (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label="Save sprite">
      <div className="modal-card">
        <div className="modal-header">
          <h3>Save sprite</h3>
        </div>
        <form className="modal-body" onSubmit={handleSubmit}>
          <label htmlFor="spriteName">Name</label>
          <input
            id="spriteName"
            ref={inputRef}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="sprite name"
          />
          <div className="modal-actions">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={!name.trim()}>Save</button>
          </div>
        </form>
      </div>
    </div>
  );

  return createPortal(overlay, document.body);
};

export default SaveDialog;